import { api, escalateError, getResponseData } from './index';

export const ServicesApi = async () => {
  await api.get('/')
    .then(getResponseData)
    .catch(escalateError);
};
